Alpine.data('newLaunch', () => ({
    banners: [],
    init() {
        $.ajax({
            url: '/api/new-launch',
            method: 'GET',
            dataType:'json',
            success: function(response){
                console.log(response);
                
            }
        })

    }
}));